import { gql } from '@apollo/client';

export const POST_CREDIT_DECISION = gql`
  mutation PostCreditDecision($entityId: String!, $fieldsObj: LenderCreditDecision) {
    postLenderCreditDecision(entityId: $entityId, fieldsObj: $fieldsObj)
  }
`;
